import { api_get, api_post, api_put, api_delete, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "redux/actions/search/searchActions";
import { ADMIN_UNIT_LOADINGS, adminUnitsTypes } from "redux/reducers/adminUnits/types";
import { extractMessage } from "helpers/extractError";

const {
  HANDLE_ADMIN_UNITS_INPUTS,
  GET_ADMIN_UNITS,
  ADD_ADMIN_UNITS,
  EDIT_ADMIN_UNIT,
  REMOVE_UNIT,
  UPDATE_UNIT_INVENTORY,
  SET_TRANSFER_BILL,
  GET_UNIT_CUSTOMERS,
  GET_CREDIT_LIMIT,
  GET_WHOLESALER_CREDIT_CONDITIONS,
  UPDATE_WHOLESALER_CREDIT_CONDITIONS,
} = adminUnitsTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
const addUnitToInvMsg = "La unidad se agregó con éxito al último inventario abierto.\nFavor de agregar la dotación y recalcular el inventario.";
const removeUnitFromInvMsg = "La unidad se eliminó del inventario con éxito.";

export const handleAdminUnitsInputsAction = (key, value) => async (
  dispatch,
) => {
  dispatch({ type: HANDLE_ADMIN_UNITS_INPUTS, payload: { key, value } });
};

export const getAdminUnitsAction = () => async (dispatch) => {
  const url = `${mainUrl}/`;
  dispatch(startRequestComp("get"));
  try {
    const data = await api_get(url);
    if (data.length === 0)
      return dispatch(setSnackbar("No hay unidades", "warning"));
    dispatch({ type: GET_ADMIN_UNITS, payload: data });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("get"));
  }
};

export const createAdminUnitsAction = (
  form,
  close = null,
  stationId = null,
) => async (dispatch) => {
  const url = `${mainUrl}/units`;
  dispatch(startRequestComp("create"));
  try {
    const response = await api_post(url, form);
    stationId &&
      dispatch({
        type: ADD_ADMIN_UNITS,
        payload: { ...response, unitPlates: response.plates, unit_type: response?.type },
      });
    dispatch(setSnackbar("Unidad creada con exito", "success"));
    close && close();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("create"));
  }
};

export const editAdminUnitsAction = (id, form, action = null) => async (
  dispatch,
) => {
  const url = `${mainUrl}/units/${id}/`;
  dispatch(startRequestComp("update"));
  try {
    await api_put(url, form);
    dispatch({
      type: EDIT_ADMIN_UNIT,
      payload: {
        ...form,
        unit_type: form.type,
        id,
      },
    });
    dispatch(setSnackbar("Unidad editada con exito", "success"));
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("update"));
  }
};

export const removeAdminUnitsAction = (id, action = null) => async (
  dispatch,
) => {
  dispatch(startRequestComp("delete"));
  const url = `${mainUrl}/units/${id}`;
  try {
    await api_delete(url);
    dispatch({ type: REMOVE_UNIT, payload: id });
    dispatch(setSnackbar("Unidad eliminada con exito", "success"));
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp("delete"));
};

export const togglePaymentTerminalAction = (idUnit, paymentTerminal, action = null) => async (
  dispatch,
  getState,
) => {
  const url = `${mainUrl}/units/${idUnit}/payment-terminal`;
  dispatch(startRequestComp("toggleTerminal"));
  try {
    await api_put(url, { hasPaymentTerminal: paymentTerminal });
    const unit = getState().unitsReducer.unitsConfigArr.find(u => u.id === idUnit);
    if (!unit) return;
    dispatch({
      type: EDIT_ADMIN_UNIT,
      payload: { id: idUnit, route: { ...unit.route, hasPaymentTerminal: paymentTerminal } },
    });
    dispatch(setSnackbar("Terminal bancaria actualizada con éxito", "success"));
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("toggleTerminal"));
  }
};

export const editAdminUnitsEmployeeAction = (id, form, action = null) => async (
  dispatch,
) => {
  const url = `${mainUrl}/units/${id}/set-employees`;
  dispatch(startRequestComp("updateUnitEmployee"));
  try {
    const response = await api_put(url, form);
    dispatch({
      type: EDIT_ADMIN_UNIT,
      payload: { ...response[0], id, idEmployee: form?.idDriver || null },
    });
    dispatch(setSnackbar("Unidad editada con exito", "success"));
    action && action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("updateUnitEmployee"));
  }
};

export const updateUnitInventory = (unitId, form) => async (dispatch) => {
  const url = `${mainUrl}/units/${unitId}/has-inventory`;
  const { hasInventory } = form;
  dispatch(startRequestComp("unitToInventory"));
  try {
    await api_put(url, form);
    dispatch({
      type: UPDATE_UNIT_INVENTORY,
      payload: { unitId, hasInventory },
    });
    const displayedMsg = hasInventory ? addUnitToInvMsg : removeUnitFromInvMsg;
    dispatch(setSnackbar(displayedMsg, "success"));
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp("unitToInventory"));
  }
};

export const fetchLinkedCustomers = (unitId) => async (dispatch) => {
  const url = `${mainUrl}/unit-wholesaler-customers?idUnit=${unitId}`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.UNIT_CUSTOMERS));
  try {
    const response = await api_get(url);
    const idCustomer = response.customers[0]?.idCustomer;  
    dispatch({
      type: GET_UNIT_CUSTOMERS,
      payload: { unitId, customer: response.customers[0] },
    });
    if (!idCustomer) {
      dispatch(setSnackbar("No tiene cliente asociado.", "warning"));
      return null;
    }
    return idCustomer;
  } catch (error) {
    dispatch(setSnackbar(error));
    return null;
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.UNIT_CUSTOMERS));
  }
};

export const getCreditLimitAction = ({ customerId, unitId }) => async (dispatch) => {
  const url = `${mainUrl}/customers/${customerId}/wholesaler-discount?idUnit=${unitId}`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.CREDIT_LIMIT));
  try {
    const response = await api_get(url);
    const creditLimit = response.discount;
    dispatch({
      type: GET_CREDIT_LIMIT,
      payload: { unitId, creditLimit },
    });
    if (creditLimit == null) {
      dispatch(setSnackbar("No se encontró límite de crédito.", "warning"));
    }
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.CREDIT_LIMIT));
  }
};

export const getWholesalerConditions = ({ unitId }) => async (dispatch) => {
  const url = `${mainUrl}/unit-wholesaler-conditions?idUnit=${unitId}`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.GET_CREDIT_CONDITIONS));
  try {
    const response = await api_get(url); // "" cuando no hay registro
    dispatch({
      type: GET_WHOLESALER_CREDIT_CONDITIONS,
      payload: { unitId, creditConditions: response?.idUnit ? response : null },
    });
    return response || null;
  } catch (error) {
    dispatch(setSnackbar(extractMessage(error) || "Error al obtener las condiciones de crédito."));
    return null;
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.GET_CREDIT_CONDITIONS));
  }
};

export const updateWholesalerCreditConditions = ({ form }) => async (dispatch) => {
  const url = `${mainUrl}/unit-wholesaler-conditions`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.UPDATE_CREDIT_CONDITIONS));
  try {
    await api_put(url, form);
    dispatch({
      type: UPDATE_WHOLESALER_CREDIT_CONDITIONS,
      payload: form,
    });
    dispatch(setSnackbar("Condiciones de crédito actualizadas con éxito", "success"));
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.UPDATE_CREDIT_CONDITIONS));
  }
};

export const createTransferBill = ({ unitId, form }) => async (
  dispatch
) => {
  const url = `${mainUrl}/units/${unitId}/billing`;
  dispatch(startRequestComp("createBill"));
  try {
    const { data } = await api_post(url, form);
    dispatch({
      type: SET_TRANSFER_BILL,
      payload: { id: data?.id, ...form },
    });
    dispatch(setSnackbar("Factura de traslados creada con éxito.", "success"));
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp("createBill"));
  }
};

export const editTransferBill = ({ billingId, form }) => async (dispatch) => {
  const url = `${mainUrl}/units/${billingId}/billing`;
  dispatch(startRequestComp("editBill"));
  try {
    const { data } = await api_put(url, form);
    dispatch({
      type: SET_TRANSFER_BILL,
      payload: { id: data?.id, ...form },
    });
    dispatch(setSnackbar("Factura de traslados modificada con éxito.", "success"));
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp("editBill"));
  }
};

// ═══════════════════════════════════════════════════════════════════
// Dispensadores y Equipo Electrónico de Unidad
// ═══════════════════════════════════════════════════════════════════

const {
  GET_UNIT_DISPENSERS,
  ADD_UNIT_DISPENSER,
  EDIT_UNIT_DISPENSER,
} = adminUnitsTypes;

// ── Catálogos para el flujo de asignación ──

/**
 * GET /crm/equipments/available → dropdown "Número" (equipo concreto).
 * Params opcionales: stations, idEquipmentType, idCurrent.
 * `idCurrent` incluye el equipo ya asignado (ASSIGNED) para poder editar.
 * Regresa la lista sin guardarla en Redux: cada formulario la guarda en su estado.
 */
export const getAvailableEquipment = ({ stations, idEquipmentType, idCurrent } = {}) => async (
  dispatch,
) => {
  const params = new URLSearchParams();
  if (stations) params.append("stations", stations);
  if (idEquipmentType) params.append("idEquipmentType", idEquipmentType);
  if (idCurrent) params.append("idCurrent", idCurrent);
  const query = params.toString();
  const url = `${mainUrl}/equipments/available${query ? `?${query}` : ""}`;
  try {
    return await api_get(url);
  } catch (error) {
    dispatch(setSnackbar(error));
    return [];
  }
};

// ── Dispensadores (solo ESTACION) ──

// GET /crm/units/:id/dispensers/detail → trae el equipo ya resuelto por dispensador.
// `silent` evita el loading GET_DISPENSERS, que desmonta las pestañas abiertas del modal.
export const getUnitDispensers = (unitId, { silent = false } = {}) => async (dispatch) => {
  const url = `${mainUrl}/units/${unitId}/dispensers/detail`;
  if (!silent) dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.GET_DISPENSERS));
  try {
    const response = await api_get(url);
    dispatch({ type: GET_UNIT_DISPENSERS, payload: { unitId, dispensers: response } });
    return response;
  } catch (error) {
    dispatch(setSnackbar(error));
    return null;
  } finally {
    if (!silent) dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.GET_DISPENSERS));
  }
};

export const addUnitDispenser = (unitId, form, onSuccess) => async (dispatch) => {
  const url = `${mainUrl}/units/${unitId}/dispensers`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.SAVE_DISPENSER));
  try {
    const response = await api_post(url, form);
    dispatch({ type: ADD_UNIT_DISPENSER, payload: { unitId, dispenser: response } });
    dispatch(setSnackbar("Dispensador creado con éxito", "success"));
    if (onSuccess) onSuccess(response);
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.SAVE_DISPENSER));
  }
};

export const editUnitDispenser = (unitId, dispenserId, form, onSuccess) => async (dispatch) => {
  const url = `${mainUrl}/units/${unitId}/dispensers/${dispenserId}`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.SAVE_DISPENSER));
  try {
    const response = await api_put(url, form);
    dispatch({ type: EDIT_UNIT_DISPENSER, payload: { unitId, dispenserId, dispenser: response } });
    dispatch(setSnackbar("Dispensador actualizado con éxito", "success"));
    if (onSuccess) onSuccess(response);
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.SAVE_DISPENSER));
  }
};

// ── Equipo Electrónico asignado (ESTACIONARIO) ──

// PUT /crm/units/:id/equipment → body { idEquipment }, response { id, idEquipment }
export const assignUnitEquipment = (unitId, form, onSuccess) => async (dispatch) => {
  const url = `${mainUrl}/units/${unitId}/equipment`;
  dispatch(startRequestComp(ADMIN_UNIT_LOADINGS.ASSIGN_EQUIPMENT));
  try {
    const response = await api_put(url, form);
    // Actualiza la fila de la unidad para que el prefill (data.idEquipment)
    // refleje el equipo recién asignado al reabrir el modal.
    dispatch({
      type: EDIT_ADMIN_UNIT,
      payload: { id: unitId, idEquipment: response?.idEquipment ?? form.idEquipment },
    });
    dispatch(setSnackbar("Equipo electrónico asignado con éxito", "success"));
    if (onSuccess) onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(ADMIN_UNIT_LOADINGS.ASSIGN_EQUIPMENT));
  }
};
